import {
  SET_USER,
  SET_ERRORS,
  CLEAR_ERRORS,
  LOADING_UI,
  STOP_LOADING_UI,
  SET_AUTHENTICATED,
  SET_UNAUTHENTICATED,
  EDIT_USER,
  UPDATE_PROFILE,
  CHANGE_IMAGE,
  LOADING_USER,
  STOP_LOADING_USER,
  RESET_DOCUMENT,
  RESET_NOTIFICATION,
  RESET_OVERVIEW,
  RESET_PROFILE,
} from '../types'
import axios from 'axios'
import { avatar } from '../../utilities/template/avatar'
import { toast } from 'react-toastify'
import { storage } from '../../config/fbConfig'
import { handleError } from '../../utilities/errorHandler/errorHandler'

import 'react-toastify/dist/ReactToastify.css'
toast.configure()

const signOutProcess = (dispatch) => {
  localStorage.removeItem('FBIdToken')
  delete axios.defaults.headers.common['Authorization']
  dispatch({ type: SET_UNAUTHENTICATED })
  dispatch({ type: RESET_DOCUMENT })
  dispatch({ type: RESET_NOTIFICATION })
  dispatch({ type: RESET_OVERVIEW })
  dispatch({ type: RESET_PROFILE })
  toast.success('Logged out successfully.', { autoClose: 2000, position: 'bottom-right' })
}


export const setAuthenticated = (state) => {
  return {
    type: SET_AUTHENTICATED,
  }
}

export const changeImage = (image, previousImageName, userId) => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    const firestore = getFirestore()
    let myData
    dispatch({ type: LOADING_USER })
    uploadImage(image, dispatch)
      .then((data) => {
        myData = data
        return firestore.collection('Users').doc(userId).update({ image: data })
      })
      .then(() => {
        dispatch({
          type: CHANGE_IMAGE,
          payload: myData,
        })
        dispatch({
          type: UPDATE_PROFILE,
          payload: {
            id: userId,
            image: myData,
          },
        })
        toast.success('Profile image changed successfully.', { autoClose: 2500, position: 'bottom-right' })
        if (previousImageName) {
          storage.ref('images').child(previousImageName).delete()
        }
      })
      .catch((error) => {
        dispatch({ type: STOP_LOADING_USER })
        handleError(error, dispatch, toast, SET_ERRORS)
      })
  }
}
export const updateUser = (profile, userId, turnOffEdit) => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    const firestore = getFirestore()
    dispatch({ type: LOADING_UI })
    // let profileRef = getState().user.credentials
    // let isNameChanged = profileRef.name === profile.name || profileRef.name === profile.name

    firestore
      .collection('Users')
      .doc(userId)
      .update(profile)
      .then(() => {
        dispatch({
          type: UPDATE_PROFILE,
          payload: { id: userId, ...profile },
        })
        dispatch({
          type: EDIT_USER,
          payload: profile,
        })

        toast.success('Profile updated successfully.', { autoClose: 2500, position: 'bottom-right' })
        turnOffEdit(false)
        dispatch({ type: STOP_LOADING_UI })
      })
      .catch((error) => {
        toast.error(error.message, { autoClose: 2500, position: 'bottom-right' })
        turnOffEdit()
        dispatch({ type: STOP_LOADING_UI })
      })
  }
}

export const changePassword = (emailAddress, setOpenModal) => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    const firebase = getFirebase()
    dispatch({ type: LOADING_UI })

    firebase
      .auth()
      .sendPasswordResetEmail(emailAddress)
      .then(function () {
        // Email sent.
        setOpenModal(false)
        toast.success('Password Reset Verification is sent to your Email.', { autoClose: 3000, position: 'bottom-right' })
        dispatch({ type: STOP_LOADING_UI })
      })
      .catch(function (error) {
        // An error happened.
        setOpenModal(false)
        toast.error(error.message, { autoClose: 2500, position: 'bottom-right' })
        dispatch({ type: STOP_LOADING_UI })
      })
  }
}
export const login = (credentials) => {
  return async(dispatch, getState, { getFirebase, getFirestore }) => {
    const firebase = getFirebase()
    let userId = ''
    dispatch({ type: LOADING_UI })
    try
    {
      const data = await firebase.auth().signInWithEmailAndPassword(credentials.email, credentials.password)
      userId = data.user.uid
      dispatch(getUserData(userId))
      const token = await data.user.getIdToken()
      setAuthorizationHeader(token)
      dispatch({ type: CLEAR_ERRORS })
      dispatch({ type: SET_AUTHENTICATED })
      toast.success('Login Success', { autoClose: 2000, position: 'bottom-right' })
      }
    catch(error)  {
      if (error.code === 'auth/user-not-found') {
        toast.error('Auth error. Please try again later.', { autoClose: 2500, position: 'bottom-right' })
      }
     else {
        toast.error(error.message, { autoClose: 2500, position: 'bottom-right' })
     }
      dispatch({
        type: SET_ERRORS,
        payload: error.message,
       })
    }

  }
}

export const signUp = (newUser) => {
  return async(dispatch, getState, { getFirebase, getFirestore }) => {
    const firebase = getFirebase()
    const firestore = getFirestore()
    let currentTimestamp = new Date().toISOString()
    dispatch({ type: LOADING_UI })
    const name = newUser.name
    const email = newUser.email
    const initial =
      name.indexOf(' ') >= 0
        ? name.substr(0, name.indexOf(' ')).substring(0, 20) // get the name before first blank space and within 20 characters
        : name.substring(0, 20)
    let userId = ''
    try{
        const data = await firebase.auth().createUserWithEmailAndPassword(newUser.email, newUser.password)
        const token = await data.user.getIdToken()
        userId = data.user.uid
        let credentials = {
          name,
          email,
          initial,
          role: 'Requester',
          hpNumber: '',
          image: {
            url: avatar,
            name: null,
          },
          createdAt: currentTimestamp,
          position: '',
          location: '',
          title: '',
        }
        await  firestore.collection('Users').doc(userId).set(credentials)
        await firestore
        .collection('Overviews')
        .doc(userId)
        .set({
          email,
          docFromYou: {
            Completed: 0,
            Expired: 0,
            Rejected: 0,
          },
          docToYou: {
            Completed: 0,
            Expired: 0,
            Rejected: 0,
          },
        })
        setAuthorizationHeader(token)
        dispatch({ type: CLEAR_ERRORS })
        dispatch({ type: SET_AUTHENTICATED })
        toast.success('Signed Up Successfully', { autoClose: 2000, position: 'bottom-right' })
      }catch(error){
        toast.error(error.message, { autoClose: 2500, position: 'bottom-right' })
        dispatch({
          type: SET_ERRORS,
          payload: error.message,
        })
      }
  }
}

export const forceSignOut = () => (dispatch) => {
  signOutProcess(dispatch)
}

export const signOut = () => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    const firebase = getFirebase()
    firebase
      .auth()
      .signOut()
      .then(() => {
        signOutProcess(dispatch)
      })
  }
}

export const getUserData = (userId, currentTimestamp = null) => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    const firestore = getFirestore()
    firestore
      .collection('Users')
      .doc(userId)
      .get()
      .then((doc) => {
        if (doc.exists) {
          const credentials = {
            ...doc.data(),
            id: doc.id,
            ...(currentTimestamp && {
              lastOnlineTimestamp: currentTimestamp,
            }),
          }
          dispatch({
            type: SET_USER,
            payload: credentials,
          })
        } else {
          toast.error('Error loading the user. Please try again later.', { autoClose: 2500, position: 'bottom-right' })
        }
      })
      .catch((error) => {
        console.log(error)
      })
  }
}

const setAuthorizationHeader = (token) => {
  const FBIdToken = `Bearer ${token}`
  localStorage.setItem('FBIdToken', FBIdToken)
  axios.defaults.headers.common['Authorization'] = FBIdToken
}

const uploadImage = (image, dispatch) => {
  return new Promise((resolve, reject) => {
    let uploadTask
    const formattedName = Date.now() + '-' + image.name
    const storageRef = storage.ref(`images/${formattedName}`)

    Object.defineProperty(image, 'name', {
      writable: true,
      value: formattedName,
    }) // change the name of image to newly formatted name
    uploadTask = storageRef.put(image)

    uploadTask.on(
      'state_changed',
      (snapshot) => {},
      (error) => {
        reject(error)
      },
      () => {
        storage
          .ref(`images`)
          .child(formattedName)
          .getDownloadURL()
          .then((url) => {
            dispatch({
              type: CHANGE_IMAGE,
              payload: image,
            })
            resolve({ url, name: formattedName })
          })
          .catch((error) => {
            reject(error)
          })
      }
    )
  })
}
